import React from "react";

const KpiSkeleton = ({ gridClass }) => (
  <div className={`card-statistic-panel kpi-card ${gridClass}`}>
    <div className="dashboard-placeholder skeleton-kpi-label" />
    <div className="dashboard-placeholder skeleton-kpi-value" />
  </div>
);

const SupervisorStatisticsSkeleton = () => (
  <div
    className="dashboard-grid-statistic-panel supervisor-dashboard-skeleton"
    role="status"
    aria-label="Cargando estadísticas de la planta"
  >
    <KpiSkeleton gridClass="grid-item-1" />
    <KpiSkeleton gridClass="grid-item-2" />
    <KpiSkeleton gridClass="grid-item-3" />

    <div className="card-statistic-panel grid-item-7 skeleton-weekly-panel">
      <div className="dashboard-placeholder skeleton-section-title" />
      <div className="skeleton-flat-list">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="skeleton-activity-row" key={index}>
            <div className="skeleton-row-copy">
              <div className="dashboard-placeholder skeleton-row-title" />
              <div className="dashboard-placeholder skeleton-row-meta" />
            </div>
            <div className="dashboard-placeholder skeleton-row-badge" />
          </div>
        ))}
      </div>
    </div>

    <div className="card-statistic-panel grid-item-5 skeleton-chart-panel">
      <div className="dashboard-placeholder skeleton-section-title" />
      <div className="skeleton-chart-plot">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="skeleton-chart-gridline" key={index} />
        ))}
      </div>
      <div className="skeleton-chart-labels">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="dashboard-placeholder" key={index} />
        ))}
      </div>
    </div>

    <div className="card-statistic-panel grid-item-6 skeleton-inspectors-panel">
      <div className="dashboard-placeholder skeleton-section-title" />
      <div className="skeleton-inspector-row">
        <div className="dashboard-placeholder skeleton-inspector-avatar" />
        <div className="skeleton-row-copy">
          <div className="dashboard-placeholder skeleton-row-title" />
          <div className="dashboard-placeholder skeleton-row-meta" />
        </div>
      </div>
    </div>
  </div>
);

export default SupervisorStatisticsSkeleton;
